import React from "react";
import PropTypes from "prop-types";

const Divider = ({ skipStart, skipEnd, loadPage }) => {
  const difference = skipEnd - skipStart - 1;

  return (
    <div data-gap="true">
      <button
        onClick={() => loadPage(skipStart + 1, false)}
        className="loadNextBtn"
      >
        Page {skipStart + 1}
      </button>

      <span>
        Skipping {difference} page{difference > 1 ? "s" : ""}
      </span>

      {difference > 1 && (
        <button onClick={() => loadPage(skipEnd - 1)} className="loadPrevBtn">
          Page {skipEnd - 1}
        </button>
      )}
    </div>
  );
};

Divider.propTypes = {
  skipStart: PropTypes.number.isRequired,
  skipEnd: PropTypes.number.isRequired,
  loadPage: PropTypes.func.isRequired,
};

export default Divider;
